export const numberSerializer = { read: (value): number => +value };
export const booleanSerializer = { read: (value): boolean => Boolean(+value) };
